import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import Professor from "../assets/Professor.svg";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";

import useForm from "../providers/useForm";

function TelaInicio() {
  const setView = useForm((state) => state.setView);

  return (
    <Box>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{ px: 3 }}
      >
        <Box sx={{ textAlign: "center", px: 2 }}>
          <img
            alt="Professor"
            src={Professor}
            style={{
              marginTop: 20,
              display: "inline-block",
              maxWidth: "100%",
              width: 450,
            }}
          />
        </Box>
        <Box>
          <Typography
            align="center"
            color="inherit"
            sx={{
              color: "#D14343",
            }}
            variant="h3"
          >
            Seja bem-vindo!
          </Typography>
        </Box>
        <Card sx={{ width: { xs: "100%", md: "70%", lg: "60%" } }}>
          <CardContent>
            <Box>
              <Typography sx={{ p: 1, mb: 1 }}>
                Para mim, como diretor, a opinião dos nossos professores é muito
                importante. Utilize este canal para enviar críticas, sugestões,
                elogios ou relatar qualquer situação que precise da nossa
                atenção. Todas as mensagens são encaminhadas diretamente para
                mim e para o setor de Qualidade, garantindo uma análise
                cuidadosa do seu relato.
              </Typography>
            </Box>
            <Button
              onClick={() => setView("TelaUnidades")}
              fullWidth
              variant="contained"
              color="success"
              endIcon={<PlayCircleFilledWhiteIcon />}
              sx={{ mt: 1 }}
            >
              {" "}
              INICIAR{" "}
            </Button>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
}

export default TelaInicio;
